import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CoachSessionPrepInterventionOptions } from "@/lib/behavior/viewModels/coachSessionPrepVeera";

interface CoachSessionPrepInterventionOptionsCardProps {
  options: CoachSessionPrepInterventionOptions;
  onOpenEvidenceReference?: (reference: {
    label: string;
    link: string | null;
    evidenceId?: string | null;
    sourceRevision?: string;
    source?: "coach_veera_brief";
  }) => void;
}

export function CoachSessionPrepInterventionOptionsCard({
  options,
  onOpenEvidenceReference,
}: CoachSessionPrepInterventionOptionsCardProps) {
  return (
    <Card className="border-border/60 bg-background/85">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Intervention Options</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 p-4 pt-0">
        {options.options.map((option) => (
          <div key={option.id} className="space-y-2 rounded-xl border border-border/50 bg-muted/20 p-3">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-sm font-medium text-foreground">{option.title}</h3>
              <Badge variant={option.confidenceLabel === "high" ? "default" : "secondary"} className="capitalize">
                {option.confidenceLabel}
              </Badge>
              {option.exploratory ? (
                <Badge variant="outline">Exploratory</Badge>
              ) : null}
            </div>

            <p className="text-sm leading-6 text-foreground">{option.purpose}</p>

            <div className="space-y-1">
              <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">Tradeoff</p>
              <p className="text-sm leading-6 text-foreground">{option.tradeoff}</p>
            </div>

            <div className="space-y-1">
              <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">Watchout</p>
              <p className="text-sm leading-6 text-foreground">{option.watchout}</p>
            </div>

            {option.evidenceRefs.length > 0 ? (
              <div className="flex flex-wrap gap-2 pt-1">
                {option.evidenceRefs.map((entry) => (
                  <Button
                    key={`${option.id}-${entry.id}`}
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => onOpenEvidenceReference?.({
                      label: entry.label,
                      link: entry.route,
                      evidenceId: entry.id,
                        sourceRevision: entry.sourceRevision,
                      source: "coach_veera_brief",
                    })}
                  >
                    {entry.label}
                  </Button>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
